// Sibling base of `kMatterArtifactVersionsBasePath` (`/api/v2/matter-artifact/versions`) in
// `src/matter-artifacts/constants.ts` — template endpoints hang off the artifact root.
export const kMatterArtifactBasePath = '/api/v2/matter-artifact'

export const kMatterArtifactTemplateSelectionApiPath = (matterArtifactId: string) =>
  `${kMatterArtifactBasePath}/${encodeURIComponent(matterArtifactId)}/template-selection`

export const kMatterArtifactApplyTemplateApiPath = `${kMatterArtifactBasePath}/apply-template`

export const kMatterArtifactAppliedTemplateUrlApiPath = (matterArtifactVersionId: string) =>
  `${kMatterArtifactBasePath}/versions/${encodeURIComponent(matterArtifactVersionId)}/applied-template-url`
